<template lang='pug'>
div(class='constructing')
  div(class='title') Договор {{ step.step_info.num }} от &laquo;{{ step.step_info.date | date }}&raquo;
  v-layout(row wrap)
    v-flex(xs12 sm12 md6)
      div(class='pt-4')
        v-img(:src='house' :lazy-src='house')
    v-flex(xs12 sm12 md5 offset-md1)
      v-list(two-line)
        v-list-tile(
          v-for='(stage, index) in stages'
          :class='{ "current-stage": currStage === index }'
          :key='stage.id'
          @click='setStage(index)'
        )
          v-list-tile-avatar(:size='42') {{ stage.alias }}
          v-list-tile-content
            v-list-tile-title(v-text='stage.text')
  v-flex(xs12)
    rhtml(:html='step.html')
  v-flex(xs12)
    images(:html='step.images')
</template>

<script>
import Html from './Html'
import Images from './Images'

export default {
  props: ['step'],

  components: {
    Rhtml: Html,
    Images
  },

  data: () => ({
    currStage: 0
  }),

  methods: {
    setStage(stage) {
      this.currStage = stage
    }
  },

  computed: {
    stages() {
      let { progress_stack } = this.step.step_info
      return progress_stack.filter(x => x.posled).reverse()
    },

    house() {
      let { posled } = this.stages[this.currStage]
      return `/houses/${posled}.png`
    }
  }
}
</script>

<style scoped>
.constructing >>> .v-avatar {
  font-size: 13px;
  font-weight: 900;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.12);
}
.constructing >>> .v-list__tile__title {
  height: auto;
  line-height: 1.35;
  white-space: unset;
}
.current-stage >>> .v-avatar {
  color: white;
  background: #27ae60;
}
</style>
